export default __webpack_public_path__ + "static/Dinesh-08679aaf7eadcd129cadaa58aff3a3d2.jpg";